import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';

export class Series {
  public static async getSeries(body: any) {
    const url = '/Series/GetAll';
    const response: AxiosResponse = await axios.post(url, body);
    return response;
  }

  public static async unreserveMarkinkCode(body: any) {
    const url = '/Series/UnreserveMarkingCodes';
    const response: AxiosResponse = await axios.post(url, body);
    return response;
  }

  public static async detailedSeries(body: any) {
    const url = '/Series/Detailed';
    const response: AxiosResponse = await axios.post(url, body);
    return response;
  }
}
